interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "LSL";
};

const LSL: Currency = Object.freeze({
  "displayName": "Lesotho Loti",
  "numericCode": 426,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "LSL",
  "symbol": "L"
});

export { LSL };
